import React, { useEffect, useState } from 'react';
import { Button, Card, Checkbox, Form, Input, Select, Space, Modal } from 'antd';
import StoreSettingService from "services/store_setting";
import ImagePicker from "components/pickers/image/MultiImagePicker"
import { useForm, useWatch } from "antd/es/form/Form";
import { useApp } from 'contexts/app';
import BankList from "./BankList"
const service = new StoreSettingService();


const WebsiteSetting = () => {
    const [form] = useForm();
    const [otpForm] = useForm();
    const { showLoading, showNotify, message } = useApp();
    const [oldSetting, setOldSetting] = useState({})
    const [idOtp, setIdOtp] = useState();
    const [isShowOtp, setIshowOpt] = useState(false)
    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        var setting = await service.getBankTranfer();
        form.setFieldsValue(setting);
        setOldSetting(setting);
    }

    const onFinish = async values => {
        // console.log('Success:', values);
        var bank = BankList.find(x => x.code == values.code);
        values = { ...values, bank_short_name: bank.short_name, bank_name: bank.bank_name, bank_bin: bank.bank_bin }

        showLoading(true);
        var { otp } = await service.saveBankTranfer(values);
        // var { otp } = { "otp": { "id": "2247afbb-51b5-46c0-812c-e7692199b208" } };
        setIdOtp(otp.id);
        showLoading(false)
        setIshowOpt(true)

    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };



    const onOtpFinish = async () => {
        const data = { ...otpForm.getFieldsValue(), id: idOtp };
        showLoading(true);
        try {
            await service.saveBankTranferWithOTP(data);
            await loadData();
            showNotify("Đã cập nhật");
            setIshowOpt(false)
        } catch (error) {
            message.error(error.message)
        }
        showLoading(false)

    }
    return (

        <>
            <Card title="Thông tin ngân hàng">

                <Form
                    form={form}
                    name="basic"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    style={{ maxWidth: 600 }}
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Ngân hàng"
                        name="code"
                        rules={[{
                            required: true,
                        },
                        ]}
                    >
                        <Select options={BankList.map(x => ({ value: x.code, label: x.name }))} showSearch />
                    </Form.Item>


                    <Form.Item
                        label="Số tài khoản"
                        name="account"
                        rules={[{ required: true, message: 'Bạn phải nhập số tài khoản' }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Tên chủ tài khoản"
                        name="name"
                        rules={[{ required: true, message: 'Bạn phải nhập tên chủ tài khoản' }]}
                    >
                        <Input />
                    </Form.Item>











                    <Form.Item label={null}>
                        <Button type="primary" htmlType="submit">
                            Cập nhật
                        </Button>
                    </Form.Item>
                </Form>
            </Card>

            <Modal
                title="Xác nhận opt"
                maskClosable={false}
                open={isShowOtp}
                onOk={e => otpForm.submit()}
                onCancel={e => setIshowOpt(false)}
                onClose={e => setIshowOpt(false)}
                okText="Xác nhận"
            >

                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                    <Form layout="vertical" form={otpForm} initialValues={{}} onFinish={onOtpFinish} style={{ width: "100%" }} >

                        <Form.Item
                            label="OTP"
                            name="otp"
                            rules={[
                                {
                                    required: true,
                                },
                                {
                                    pattern: /^[0-9]{4}$/,
                                    message: "OTP must be a 4-digit number",
                                },
                            ]}
                        >
                            <Input.OTP length={4} style={{ width: "100%" }} />
                        </Form.Item>


                    </Form>
                </div>
            </Modal>

        </>
    )
}
export default WebsiteSetting;